import helper from '@/mixins/helpers'
const nordeaInvoiceLogExportReport = (data) => {
  var list = data.invoices
  const settings = data.commonsetting
  const dates = { from: data.fromdate, till: data.tilldate }
  let getContent = ''
  let calculationBasedOnCurrency = {}
  for (let i = 0; i < list.length; i++) {
    list[i] = {
      currency: list[i].invoice.currencydata ? JSON.parse(list[i].invoice.currencydata || {}) : {},
      invoice: list[i].invoice,
      order: list[i].invoice.orderdata ? JSON.parse(list[i].invoice.orderdata || {}) : {},
      customer: list[i].invoice.customerdata ? JSON.parse(list[i].invoice.customerdata || {}) : {}
    }
    getContent += '<tr>'
    let currencyName = list[i].currency && list[i].currency.Name ? list[i].currency.Name : 'NOK'
    if (!calculationBasedOnCurrency[currencyName]) calculationBasedOnCurrency[currencyName] = { sum_ex_vat: 0, mva: 0, sum_ink_vat: 0, qty: (list.length || 0), round_down: 0 }
    calculationBasedOnCurrency[currencyName].sum_ex_vat += list[i].invoice.total_sum
    calculationBasedOnCurrency[currencyName].sum_ink_vat += list[i].invoice.grand_total
    calculationBasedOnCurrency[currencyName].round_down += list[i].invoice.rounding_value
    getContent += `<td class="th-fontsize" style="border-top:none;">${list[i].order.Number || ''}</td>`
    getContent += `<td class="th-fontsize" style="border-top:none;">${getInvoiceCreatedType(list[i].invoice.type || '')}</td>`
    getContent += `<td class="th-fontsize" style="border-top:none;">${list[i].invoice.number || ''}</td>`
    getContent += `<td class="th-fontsize" style="border-top:none;">${list[i].customer.Custom_Number || ''}</td>`
    getContent += `<td class="th-fontsize" style="border-top:none;">${list[i].customer.Name || ''}</td>`
    getContent += `<td class="th-fontsize" style="border-top:none;">${list[i].invoice.your_reference || ''}</td>`
    getContent += `<td class="th-fontsize" style="border-top:none;">${list[i].order && list[i].order.DeliveryDate ? helper.methods.$_formatDate(list[i].order.DeliveryDate, 'YYYY-MM-DD', 'DD.MM.YYYY') : ''}</td>`
    getContent += `<td class="th-fontsize" style="border-top:none;">${list[i].order && list[i].invoice.invoice_date ? helper.methods.$_filterDate(list[i].invoice.invoice_date) : ''}</td>`
    getContent += `<td class="th-fontsize" style="border-top:none;">${list[i].order && list[i].invoice.due_date ? helper.methods.$_filterDate(list[i].invoice.due_date) : ''}</td>`
    getContent += `<td class="th-fontsize text-right" style="border-top:none;">${helper.methods.$_thousandSeparator(list[i].invoice.total_sum)}</td>`
    getContent += `<td class="th-fontsize text-right" style="border-top:none;">${helper.methods.$_thousandSeparator(list[i].invoice.total_sum)}</td>`
    getContent += `<td class="th-fontsize text-right" style="border-top:none;">${helper.methods.$_thousandSeparator(((helper.methods.getRoundedNumberWithPrecision(list[i].invoice.grand_total, 0) - list[i].invoice.rounding_value) - list[i].invoice.total_sum))}</td>`
    getContent += `<td class="th-fontsize text-right" style="border-top:none;">${helper.methods.$_thousandSeparator(list[i].invoice.grand_total, 0)} ${currencyName}</td>`
    getContent += '</tr>'
  }
  Object.keys(calculationBasedOnCurrency).forEach(key => {
    calculationBasedOnCurrency[key].mva = ((calculationBasedOnCurrency[key].sum_ink_vat + calculationBasedOnCurrency[key].round_down) - calculationBasedOnCurrency[key].sum_ex_vat)
  })
  const totalData = getTotalContent(calculationBasedOnCurrency)
  return content(getContent, calculationBasedOnCurrency, settings, dates, totalData)
}

const getTotalContent = (currencies) => {
  let content = ''
  Object.keys(currencies).forEach(key => {
    content += `<div class="row">
        <div class="col-xs-7">
          Sum eksl mva ${key}
        </div>
        <div class="col-xs-5">
          ${helper.methods.$_replaceDotWithComma(currencies[key].sum_ex_vat || 0)} ${key || 'NOK'}
        </div>
      </div>`
  })
  Object.keys(currencies).forEach(key => {
    content += `
      ${currencies[key].mva > 0 ? `<div class="row">
        <div class="col-xs-7">
          Sum mva ${key}
        </div>
        <div class="col-xs-5">
          ${helper.methods.$_replaceDotWithComma(currencies[key].mva || 0)} ${key || 'NOK'}
        </div>
      </div>` : ''}`
  })
  Object.keys(currencies).forEach(key => {
    content += `
      ${currencies[key].mva > 0 ? `<div class="row">
        <div class="col-xs-7">
          Sum inkl mva ${key}
        </div>
        <div class="col-xs-5">
          ${helper.methods.$_replaceDotWithComma(currencies[key].sum_ink_vat || 0)} ${key || 'NOK'}
        </div>
      </div>` : ''}`
  })
  content += `<div class="row">
      <div class="col-xs-7">
        Antall
      </div>
      <div class="col-xs-5">
        ${helper.methods.$_replaceDotWithComma(currencies[Object.keys(currencies)[0]].qty || 0)}
      </div>
    </div>`
  return content
}
const content = (content, payload, settings, dates, totalContent) => btoa(unescape(encodeURIComponent(`
<html>
  <head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css">
    <style>
      thead { display: table-header-group; font-size: 11px; }
      tfoot { display: table-row-group; }
      .products_list tr { page-break-inside: avoid; }
      .table tr, .table tr td { page-break-inside: avoid; }
      .table tr td, .table tr th { font-size: 14px; }
      tbody tr td { text-align: justify;word-break: break-word;padding: 3px !important;}
      .noso_header{ font-size: 12px; color: #999; }
      .table tr td, .table tr th { font-size: 14px; }
      tbody tr:nth-child(odd) { background: #d7d6d6 }
    </style>
  </head>
  <body>
    <div class="container-fluid">
      <hr style="height:2px;border:none;color:#333;background-color:#333;">
      <div class="row">
        <div class="col-xs-6">
          <b>Fakutralogg</b>
        </div>
        <div class="col-xs-6 noso_header">
          <b>${settings ? settings.partyname || '&nbsp;' : '&nbsp;'}</b>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6" style="padding-top:25px">
          <b>Fra Dato </b> ${dates && dates.from ? helper.methods.$_filterDate(dates.from) : '&nbsp;'} &nbsp; &nbsp;
          <b>Til Dato: </b> ${dates && dates.till ? helper.methods.$_filterDate(dates.till) : '&nbsp;'}
        </div>
        <div class="col-xs-6 noso_header">
          <div class="row">
            <div class="col-xs-2">
              Telefon:
            </div>
            <div class="col-xs-3">
            ${settings ? settings.contacttelephone || '&nbsp;' : '&nbsp;'}
            </div>
            <div class="col-xs-7">
            ${settings ? settings.contactemail || '&nbsp;' : '&nbsp;'}
            </div>
          </div>
          <div class="row">
            <div class="col-xs-5">
              <b>Foretakregisteret:</b>
            </div>
            <div class="col-xs-7">
            ${settings ? settings.web || '&nbsp;' : '&nbsp;'}
            </div>
          </div>
          <div class="row">
            <div class="col-xs-2">
              Org.nr.
            </div>
            <div class="col-xs-3">
            ${settings ? settings.organizationnumber + 'MVA' : '&nbsp;'}
            </div>
            <div class="col-xs-7">
            IBAN. ${settings ? settings.sg_financial_payment_identifier_international || '&nbsp;' : '&nbsp;'}
            </div>
          </div>
          <div class="row">
            <div class="col-xs-2">
              Konto.nr.
            </div>
            <div class="col-xs-3">
            ${settings ? settings.sg_financial_payment_identifier || '&nbsp;' : '&nbsp;'}
            </div>
            <div class="col-xs-7">
              Swift. ${settings ? settings.sg_financial_institution_branch || '&nbsp;' : '&nbsp;'}
            </div>
          </div>
        </div>
      </div>
      <hr style="height:3px;border:none;color:#333;background-color:#333;">
      <div class="row">
        <div class="col-xs-12">
          <table style="width: 100%" class="pull-right table">
            <thead class="bottom_border">
              <th>Ordre nr</th>
              <th>Kategori</th>
              <th>Kategori Nr</th>
              <th>Kunde Nr</th>
              <th>Faktura navn</th>
              <th>Referanse</th>
              <th>Lev Dato</th>
              <th>Fakturet</th>
              <th>Bet Frist</th>
              <th>Sum Netto pris</th>
              <th>Sum Netto pris valuta</th>
              <th>Mva</th>
              <th>Sum Brutto pris</th>
            </thead>
            <tbody class="bottom_border">
              <tr>
                ${content}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6"></div>
        <div class="col-xs-6 text-right">
          ${totalContent}
        </div>
      </div>
    </div>
  </body>
</html>
`)))
const getInvoiceCreatedType = (type) => {
  const types = [{
    text: 'Faktura',
    value: 1
  }, {
    text: 'Kreditnota',
    value: 2
  }]
  const getType = types.find(x => x.value === type)
  if (getType) return getType.text
  else return ''
}
export default nordeaInvoiceLogExportReport
